import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import ajaxCard from "../../util/remote/ajaxCard";


const DeleteCard=(props)=>{

    const [loading, setLoading] = useState(false)
    const data = {
        card_id: props.cardID,
      };

    const handleUpdate = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxCard.deleteCard(data);
        setLoading(false);
        if(server_response.status==="OK"){
            toast.success(server_response.message);
            props.countAllCards()
            props.getAllCards(props.page)
            props.getUnassignedCards(props.unassignedPage)
        }
        else{
            toast.error(server_response.message); 
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleUpdate}>Confirm<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Delete Buzz Card / Wristband"
            id="model-card-del"
            size="md"
            footer={RenderFooter}
        >

        <div className="row">
        <div className="bg-white">
			    <div className="alert text-center">
				    <i className="fe fe-alert-circle fs-50 text-danger" style={{fontSize:"50px"}}></i>
			        <h3 className="mt-2 mb-1">Are you sure you want to delete this buzz card / wristband?</h3>
				    <p className="mb-3 mb-3 tx-inverse">This will be erased completely from the system.</p>
				</div>
			</div>
        </div>
       
        </SystemModal>
    )
}

export default DeleteCard
